import OrderSummaryCard from './orderSummaryCard';

export default OrderSummaryCard;
